export const COL_MARGIN_VALUE = 12;
export const MAX_CARDS_NUMBER_FOR_ONE_ROW = 3;
